module.exports = __webpack_public_path__ + "static/media/4.f2f27c73.jpg";